import type { IChipProps } from '@mofid-securities/uikit';
import type { TFundTransactionStatus } from '@/services/apis/fund/types';

const DEFAULT_STATUS_VARIANT = 'default';
const STATUS_VARIANT_MAP: Record<
  TFundTransactionStatus,
  IChipProps['variant']
> = {
  WaitForAccept: 'warning',
  CanceledByCustomer: 'default',
  Created: 'warning',
  Pending: 'warning',
  Rejected: 'error',
  Deleted: 'error',
  Failed: 'error',
  Done: 'success',
};

export const getFundTransactionStatusVariant = (
  status: TFundTransactionStatus
): IChipProps['variant'] => {
  return STATUS_VARIANT_MAP[status] || DEFAULT_STATUS_VARIANT;
};
